<ul ngbNav [activeId]="activeTabId" class="nav nav-tabs-custom nav-justified_ card-header-tabs border-bottom-0_ m-tabs">
	<li *ngFor="let tab of tabs; let i = index" [ngbNavItem]="i + 1">
		<a ngbNavLink class="w-md text-center text-capitalize" (click)="onTabSelect(tab[bindValue])">
			{{ tab[bindLabel] }} <span class="badge bg-primary-subtle text-primary align-middle rounded-pill ms-1">{{ tab?.count }}</span>
		</a>
	</li>
</ul>
